import { _request, APIBaseResponse,APIMethod } from '../';

const CLAIMDATATYPES_PATH_PREFIX = '/claimdatatypes';

type APIClaimDataTypeGetListResponse = APIBaseResponse<
    Array<{
        id: string;
        name: string;
        description: string;
    }>
>;

export const APIClaimDataTypeGetList: APIMethod<void, APIClaimDataTypeGetListResponse> = () => (
    _request('GET', CLAIMDATATYPES_PATH_PREFIX)
);
